module.exports = __webpack_public_path__ + "article-7051a3ee/bewerbungsfoto-18c56b9fa0b0ca98b3f698ff56f11c23.jpg";